<template>
  <div class="playvideo">
    <video
      crossorigin="anonymous"
      name="playvideocon"
      class="playvideocon"
      ref="video"
      :src="videoUrl"
      preload="meta"
      @ended="playend"
      @contextmenu.prevent
      @click="clickVideo"
    >Your browser is too old which doesn't support HTML5 video.</video>
    <img v-if="videoBeginPoster" src="/static/img/video/gotoclass-img.png" alt="上课啦">
    <img v-show="videoEnd" src="/static/img/video/classover.jpg" alt="下课啦">
    <div
      class="bottom"
      @mouseenter="bottomShow = true"
      @mousemove="bottomShowFn"
      @mouseleave="bottomShow = false"
    >
      <transition name="fade">
        <template v-if="lesson_type === 1">
          <div class="bottom_sub" v-show="bottomShow && progressBar && playBar" @click.stop>
            <div class="bottom_cont">
              <img
                class="play-toggle cursor"
                @click="togglePlay"
                :src="playFlag ? '/static/img/playback/play.png':'/static/img/playback/pause.png'"
                alt
              />
              <span class="video-currentTime">{{ currentTime | time }}</span>
              <div class="input_box">
                <input
                  class="range"
                  type="range"
                  @change="range"
                  @mousedown="rangeMousedown"
                  @mouseup="rangeMouseup"
                  v-model="currentTime"
                  :max="durationTime"
                  ref="range"
                  min="0"
                  step="1"
                  :style="{
                  backgroundSize:
                    (currentTime / durationTime || 0) * 100 + '% 100%',
                }"
                />
              </div>
              <span class="video-duration">{{ durationTime | time }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="bottom_sub" v-show="bottomShow && progressBar" @click.stop>
            <div class="bottom_cont">
              <img
                class="play-toggle cursor"
                @click="togglePlay"
                :src="playFlag ? '/static/img/playback/play.png':'/static/img/playback/pause.png'"
                alt
              />
              <span class="video-currentTime">{{ currentTime | time }}</span>
              <div class="input_box">
                <input
                  class="range"
                  type="range"
                  @change="range"
                  @mousedown="rangeMousedown"
                  @mouseup="rangeMouseup"
                  v-model="currentTime"
                  :max="durationTime"
                  ref="range"
                  min="0"
                  step="1"
                  :style="{
                  backgroundSize:
                    (currentTime / durationTime || 0) * 100 + '% 100%',
                }"
                />
              </div>
              <span class="video-duration">{{ durationTime | time }}</span>
            </div>
          </div>
        </template>

      </transition>
    </div>
    <!--倍速/讲解片段-->
    <slide
      :showExeriseList="showExeriseList"
      @changeRate="changeRate"
      :rateIndex="rateIndex"
      :rateArr="rateArr"
    ></slide>
  </div>
</template>
<script>
import utils from "utils";
import { mapState, mapMutations, mapActions } from "vuex";
import common from "common";
import slide from '../playback/slide'
export default {
  props: {
    showExeriseList:{
      type:Number,
      default:1
    },
    rateArr:{
      type:Array,
      required:true
    },
    rateIndex: {
      type: Number,
      default: 3
    },
    progressBar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    slide
  },
  data() {
    return {
      videoUrl: "",
      sendLogData: "",
      sendLogArr: [],
      currentTime: 0, //视频当前播放时长
      durationTime: "", //视频总时长
      videoLoadTimeoutInterval: null,
      videoEnd:false,
      bottomShow:true,
      bottomInterval:null,
      isDrag:false,
      isCanPalyTimer: null,
      playFlag: false, //是否正在播放
      onlineTime: 0,
      isFirstComeIn: false,
      videoBeginPoster: true
    };
  },
  mounted() {
    this.getSendLogFn();
    this.eventHub();
    this.initVideo();
    this.isCanPalyTimerFun();
  },
  computed: {
    ...mapState([
      "liveVideoUrlData",
      "lesson_id",
      "exp_live_timeout",
      "live_video_mp4_appoint_time",
      "video_stream_load_timeout",
      "lesson_type",
      "class_type",
      "playbackUrl",
      "class_type",
      "oldUser",
      "class_id",
      "count_online_time_interval",
      "playBar",
      "playPoint",
      "teacher_id",
      "rtcStatus",
      "subject",
      "apiLessonInState"
    ]),
  },
  methods: {
    ...mapMutations(["upDateLessonState", "upDateApiLessonInState","updatePlaybackUrl","updatePlayPoint"]),
    ...mapActions(["getSendLog", "getSendLogForRecord", "isPlayTime", "durationRport", "continuationRport", 'lessonIn']),
    async initVideo() {
      this.destroyVideo();
      this.$emit("tip", true);
      this.lessonIn({
        lesson_id: this.lesson_id,
        device_id: utils.createDeviceId(),
        device: common.device,
        version: common.version,
        class_id: this.class_id,
        teacher_id: this.teacher_id,
        rtcStatus: this.rtcStatus,
        subject: this.subject
      })
        .then(({ res, ok })=> {
        if (!ok) {
          if (this.apiLessonInState !== 1) {
            this.upDateApiLessonInState(2);
          }
          return;
        }

        this.$root.eventHub.$emit("setEventConfig", {eventConfig: res.eventConfig});
        this.$root.eventHub.$emit("lessonInResult");
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventSwitchSoeResult",
          data: {
            source:'lessonIn',
            unique_id:'',
            soe:res.soe
          }
        });
        let videoUrl = '';
        try {
          videoUrl = res.videoUrl[0].videoUrlList[0].mp4 || '';
        } catch(e) {
          console.log('videoUrl获取失败-forai')
        }
        this.videoUrl = videoUrl;
        if (!this.videoUrl) {
          console.log('loaderr-resquest', loaderr, !this.videoUrl)
          this.$emit("loaderr");
          return;
        }
        common.set("live_video_url_now", this.videoUrl);

        if(videoUrl) {
          this.updatePlaybackUrl(videoUrl);
        }
        // console.log('videoUrl',this.videoUrl)
        this.removeEventListener();
        this.addEventListener();
        // this.videoLoadTimeout();
      })
      .catch(() => {
        if (this.apiLessonInState !== 1) {
          this.upDateApiLessonInState(2);
        }
      });
    },
    clickVideo() {
      this.$emit('clickTagSwitch', 1);
    },
    //更改倍速
    changeRate({ v, i }) {
      this.$refs.video.playbackRate = v;
      this.$emit('changeRateIndex', i);
      this.$emit('clickTagSwitch', 1);
    },
    //=>切换视频播放暂停
    togglePlay() {
      if (this.$refs.video.paused) {
        if (this.currentTime >= Math.floor(this.duration)) {
          this.$refs.video.currentTime = 0;
        }
        if(this.$refs.video.currentTime == 0) {
          this.$root.eventHub.$emit('closeClassBeginAudio');
          this.videoBeginPoster = false;
        }
        this.$refs.video.play();
        this.playFlag = true;
        this.bottomShow = false;
        if(this.videoEnd) {
          this.$root.eventHub.$emit('closeAudio');
          this.videoEnd = false;
        }
        return;
      }
      this.playFlag = false;
      this.$refs.video.pause();
    },
    // 10分钟检测一次政策是不是让播
    isCanPalyTimerFun: function () {
      this.isCanPalyTimer = setInterval(() => {
        this.isPlayTime()
          .then(({res, ok}) => {
            if (!ok) return;
            const look = res.look;
            this.isCanPlay = !look;
            if (this.isCanPlay) {
              console.log('isCanPalyTimerFun')
              this.$emit('canNotPlay', res.desc)
              this.removeEventListener();
              this.destroyVideo();
              this.videoEnd = true;
              this.$router.go(-1);
            }
          })
      }, 1000 * 60 * 10)
    },
    bottomShowFn() {
      clearTimeout(this.bottomInterval);
      if (this.bottomShow && !this.isDrag) {
        this.bottomInterval = setTimeout(() => {
          this.bottomShow = false;
        }, 5000);
      }
    },
    range() {
      // console.log('range', this.currentTime)
      this.$refs.video.currentTime = this.currentTime;
      if(this.lesson_type === 1) {
        this.handleContinuationRport();
      }
      this.$refs.video.play();
      this.playFlag = !this.$refs.video.paused;
      this.bottomShow = false;
      if(Math.floor(this.$refs.video.duration) != this.currentTime * 1) {
        this.$root.eventHub.$emit('closeAudio');
        this.videoEnd = false;
      }
    },
    rangeMousedown() {
      clearTimeout(this.bottomInterval);
      this.isDrag = true;
    },
    rangeMouseup() {
      this.isDrag = false;
    },
    getSendLogFn() {
      this.getSendLogForRecord({
        lessonId: this.lesson_id
      }).then(({ res, ok }) => {
        if (!ok) return;
        this.sendLogData = res;
        this.sendLogArr = Object.keys(this.sendLogData);
      });

    },
    eventHub() {
      this.offEventHub();
      this.$root.eventHub.$on("restartVideo", () => {
        this.reconnection();
      });
      this.$root.eventHub.$on("firstPlayVideo", () => {
        this.playVideo();
      });
      this.$root.eventHub.$on("videoMuted", muted => {
        this.$refs.video.muted = muted;
      });
      this.$root.eventHub.$on("destroyVideo", () => {
        console.log('destroyVideo-video')
        this.destroyVideo();
      });
      this.$root.eventHub.$on('classVideoPlay', ()=> {
        this.beginVideo()
      })
    },
    beginVideo() {
      console.log('beginVideo')
      this.videoBeginPoster = false;
      this.$refs.video.play();
      this.playFlag = !this.$refs.video.paused;
      if (this.$refs.video.paused) {
        this.$emit("firstPlay");
        console.log("首次进入视频自动播放失败");
      }
    },
    playVideo() {
      console.log('playVideo');
      let temServerTime = common.getTemServerTime();
      let ctime = temServerTime - (this.currentTime + this.live_video_mp4_appoint_time);
      if (ctime * 1000 > this.exp_live_timeout && this.live_video_mp4_appoint_time != 0) {
        let currentTime = temServerTime - this.live_video_mp4_appoint_time;
        if (currentTime >= this.durationTime) {
          this.destroyVideo();
          this.removeEventListener();
          this.videoEnd = true;
          return;
        }
        this.$refs.video.currentTime = currentTime;
        this.$refs.video.play();
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventTYKSeekTime",
          data: {
            client_time: temServerTime, // 客户端当前时间(秒),
            appoint_time: this.live_video_mp4_appoint_time, // 体验课开课时间(秒)
            seek_time: currentTime //seek 到的时间点(秒)
          }
        });
      } else {
        this.$refs.video.play();
      }
    },
    offEventHub() {
      this.$root.eventHub.$off("restartVideo");
      this.$root.eventHub.$off("firstPlayVideo");
      this.$root.eventHub.$off("destroyVideo");
      this.$root.eventHub.$off("videoMuted");
      this.$root.eventHub.$off('classVideoPlay');
    },
    videoLoadeddata() {
      console.log('videoLoadeddata', this.currentTime, this.lesson_type, this.isFirstComeIn,this.$refs.video.paused)
      this.$root.eventHub.$emit('closeClassBeginAudio');
      if(this.currentTime === 0 && this.lesson_type === 1) {
        this.ininCurrenttime()
        if(!this.isFirstComeIn) {
          this.$emit("tip", false);
          // this.$refs.video.poster = '/static/img/video/gotoclass-img.png';
          this.videoBeginPoster = true;
          this.isFirstComeIn = true;
          this.$emit('playClassBeginAudio')
        }else {
          console.log('this.videoBeginPoster',this.videoBeginPoster)
          this.videoBeginPoster = false;
          this.$refs.video.play();
          this.playFlag = !this.$refs.video.paused;
          if (this.$refs.video.paused) {
            this.isFirstComeIn = false;
            this.$emit("firstPlay");
            console.log("首次进入视频自动播放失败");
          }

        }
      } else {
        this.$refs.video.play();
        this.playFlag = !this.$refs.video.paused;
        if (this.$refs.video.paused) {
          this.$emit("firstPlay");
          console.log("首次进入视频自动播放失败");
        }
      }

    },
    ininCurrenttime() {
      let continuationTimes = common.get('continuationTimes');
      if(continuationTimes) {
        continuationTimes = JSON.parse(continuationTimes);
        let index = continuationTimes.findIndex(v=> v.lesson_id == this.lesson_id);
        if(index != -1) {
          let current_time = continuationTimes[index].current_time * 1;
          let useTime = current_time > this.playPoint ? current_time : this.playPoint;
          if((useTime < Math.floor(this.$refs.video.duration) - 60) && useTime != 0) {
            this.currentTime = useTime;
            this.$refs.video.currentTime = useTime;
          }
        }
      }
    },
    videoPlaying() {
      // console.log('playing');
      this.$emit("tip", false);
      clearTimeout(this.videoLoadTimeoutInterval);
    },
    videoWaiting() {
      // console.log('播放卡顿');
      this.$emit("tip", true);
      this.playVideo();
    },
    videoError() {
      console.log('videoError')
      this.$emit("loaderr");
      this.$refs.video && this.$refs.video.pause();
      this.playFlag = false;
      clearTimeout(this.videoLoadTimeoutInterval);
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventStreamLose",
        data: {
          url: this.liveVideoUrlData.live_video_url,
          cdnIP: ""
        }
      });
    },
    playend(){
      // console.log('playend')
      this.$refs.video && this.$refs.video.pause();
      this.videoEnd = true;
      this.playFlag = false;
      this.upDateLessonState(3);
      this.$root.eventHub.$emit("classOver");
    },
    videoTimeupdate() {
      // console.log('videoTimeupdate')
      this.videoBeginPoster = false;
      let element = this.$refs.video;
      let time = Math.floor(element.currentTime);
      if (time === this.currentTime || element.paused || this.isDrag) return;
      if (!this.isDrag) {
        this.uploadEffectiveOnlineTime();
      }
      this.currentTime = time;
      this.videoEnd = false;
      let selfTime = this.sendLogArr.filter(v => {
        return this.currentTime == v;
      })[0];
      if (!selfTime) return;
      this.showContent(selfTime);
      this.$root.eventHub.$emit('closeClassBeginAudio')
    },
    showContent(key) {
      const obj = this.sendLogData[key];
      // console.log('obj', obj)
      if (obj.type === "send_quick_question") {
        let datas = {
          unique_id: utils.createUniqueId(),
          data: {
            correct_answer:obj.correct_answer,
            quick_question_id: obj.value,
            type: obj.q_type,
            srv_time: common.getTemServerTime(),
            falseBarrageIndex: obj.index
          }
        };
        this.$root.eventHub.$emit("question", datas, "");
      } else if (obj.type === "add_coin") {
        let datas = {
          unique_id: " ",
          data: {
            coin: obj.value
          }
        };
        this.$root.eventHub.$emit("coin", datas);
      } else if (obj.type === "comments") {
        let datas = {
          unique_id: " ",
          data: {
            task_data: {
              show: obj.value
            }
          }
        };
        this.$root.eventHub.$emit("comments", datas);
      }
    },

    uploadEffectiveOnlineTime() {
      this.onlineTime++;
      if (
        this.onlineTime >= this.count_online_time_interval &&
        document.visibilityState === "visible"
      ) {

        this.onlineTime = 0;
        let type = 2;
        if (this.lesson_type == 1 || this.lesson_type == 5) {
          type = 3;
        }
        if (this.lesson_type == 3 || this.lesson_type == 6) {
          type = 2;
        }
        const sendData = {
          time: common.getTemServerTime(),
          event: 2001,
          data: {
            class_id: this.class_id,
            lesson_id: this.lesson_id,
            student_id: this.userID,
            type: type,
            length: this.currentTime,
          },
        };
        this.durationRport(sendData)
        if(this.lesson_type === 1) {
          this.handleContinuationRport();
        }
      }
    },
    handleContinuationRport() {
      // 续播
      this.saveTime();
      // 续播上报
      this.continuationRport({
        time: common.getTemServerTime(),
        event: 2001,
        classId: this.class_id,
        lessonId: this.lesson_id,
        type: 5,
        playPoint: this.currentTime * 1,
      })
    },
    saveTime() {
      let continuationTimes = common.get('continuationTimes');
      let obj = {
        lesson_id: this.lesson_id,
        current_time: this.currentTime
      }
      if(continuationTimes) {
        continuationTimes = JSON.parse(continuationTimes);
        let index = continuationTimes.findIndex(v=> v.lesson_id == this.lesson_id);
        if(index != -1) {
          continuationTimes[index]['current_time'] = this.currentTime;
        }else {
          continuationTimes.push(obj)
        }
      }else {
        continuationTimes = [obj]
      }
      common.set('continuationTimes', JSON.stringify(continuationTimes))
      this.updatePlayPoint(this.currentTime * 1);
    },
    videoLoadedmetadata() {
      let temServerTime = common.getTemServerTime();
      this.durationTime = Math.floor(this.$refs.video.duration);
      let currentTime = this.live_video_mp4_appoint_time == 0 ? 0 : temServerTime - this.live_video_mp4_appoint_time;
      // if (currentTime >= this.durationTime) {
      //   this.removeEventListener();
      //   this.destroyVideo();
      //   this.videoEnd = true;
      // }
    },
    removeEventListener() {
      let element = this.$refs.video;
      // element.removeEventListener("loadeddata", this.videoLoadeddata);
      element.addEventListener("canplay", this.videoLoadeddata);
      element.removeEventListener("playing", this.videoPlaying);
      element.removeEventListener("waiting", this.videoWaiting);
      element.removeEventListener("timeupdate", this.videoTimeupdate);
      element.removeEventListener("error", this.videoError);
      element.removeEventListener("loadedmetadata", this.videoLoadedmetadata);
    },
    addEventListener() {
      let element = this.$refs.video;
      // element.addEventListener("loadeddata", this.videoLoadeddata);
      element.addEventListener("canplay", this.videoLoadeddata);
      element.addEventListener("playing", this.videoPlaying);
      element.addEventListener("waiting", this.videoWaiting);
      element.addEventListener("timeupdate", this.videoTimeupdate);
      element.addEventListener("error", this.videoError);
      element.addEventListener("loadedmetadata", this.videoLoadedmetadata);
    },
    videoLoadTimeout() {
      // console.log('videoLoadTimeout', this.video_stream_load_timeout)
      clearTimeout(this.videoLoadTimeoutInterval);
      this.videoLoadTimeoutInterval = setTimeout(() => {
        this.destroyVideo();
        this.$emit("loaderr");
      }, this.video_stream_load_timeout * 1000);
    },
    reconnection() {
      // console.log('reconnection')
      this.currentTime = 0;
      this.initVideo();
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventPlayerRestart"
      });
    },
    destroyVideo() {
      // console.log('destroyVideo')
      this.videoUrl = "";
      clearTimeout(this.videoLoadTimeoutInterval);
    }
  },
  beforeDestroy() {
    // console.log('beforeDestroy')
    this.removeEventListener();
    this.destroyVideo();
    this.offEventHub();
    clearInterval(this.isCanPalyTimer);
  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.playvideo {
  width: 100%;
  height: 100%;
  vertical-align: bottom;
  position: relative;
  video {
    width: 100%;
    height: 100%;
  }
  img{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.bottom {
  width: 100%;
  height: 86px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 25;
}
.bottom_sub {
  width: 100%;
  height: 86px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.03));
  .bottom_cont {
    width: 100%;
    display: flex;
    height: 40px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    &>img.play-toggle {
      margin-left: 20px;
      margin-right: 10px;
      width: 20px;
      height: 23px;
      position: static;
    }
    .input_box {
      flex: 1;
      margin: 0 40px 0 15px;
      .range {
        width: calc(100% + 22px);
        outline: none;
        -webkit-appearance: none; /*清除系统默认样式*/
        background: -webkit-linear-gradient(#008acf, #008acf) no-repeat, #333;
        background: -o-linear-gradient(#008acf, #008acf) no-repeat, #333;
        background: -moz-linear-gradient(#008acf, #008acf) no-repeat, #333;
        background: linear-gradient(#008acf, #008acf) no-repeat, #333;
        height: 3px; /*横条的高度*/
        pointer-events: none;
      }
      /*拖动块的样式*/
      .range::-webkit-slider-thumb {
        position: relative;
        z-index: 2;
        -webkit-appearance: none; /*清除系统默认样式*/
        height: 22px; /*拖动块高度*/
        width: 22px; /*拖动块宽度*/
        background: #008acf; /*拖动块背景*/
        border-radius: 50%; /*外观设置为圆形*/
        border: 8px solid #ffffff; /*设置边框*/
        box-shadow: 0 0 0 6px hsla(0, 0%, 100%, 0.5);
        pointer-events: auto;
      }
    }
    .video-duration {
      padding-right: 10px;
      color: #ffffff;
      //text-align: left;
    }
    .video-currentTime {
      width: 80px;
      color: #ffffff;
      //text-align: right;
    }
  }

}
.fade-enter-active {
  animation: fade 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.fade-leave-active {
  animation: fade 0.3s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/videoPlayerForAi.vue